export default "/biometrie-afghanistan/media/e88aadd2da5c2260882a9584eed18125~header-768w.jpg";